import React from 'react';
import './App.css';
import {
    FaTwitter,
    FaTelegramPlane,
    FaLinkedinIn,
    FaInstagram,
} from 'react-icons/fa';

function App() {
    return (
        <div className="container">
            <header>
                <img src={process.env.PUBLIC_URL + '/images/photo.png'} alt="Rail Akhmetov" className="profile-photo" />
                <h1>Rail Akhmetov</h1>
                <div className="bio">
                    <p className="bio-title">Vibe Entrepreneur</p>
                    <p className="bio-secondary">Running a portfolio of apps with AI agents. Ex-VC &rarr; builder.</p>
                    <p className="bio-tagline">I don't run my businesses. My agents do.</p>
                </div>
            </header>

            <main>
                <section className="manifesto">
                    <p>
                        Vibe coding let anyone write software.
                        Vibe marketing let anyone run campaigns.
                        Vibe entrepreneurship is what happens when you stack them together &mdash; and
                        let AI agents run the whole business while you focus on vision and vibes.
                    </p>
                    <p>
                        The key ingredient: build only what you genuinely enjoy.
                        Cold plunges, chess, dating, ads &mdash; every app here started as a personal obsession.
                        Agents handle the business. I handle the taste.
                    </p>
                    <p className="manifesto-meta">
                        One founder. 10+ apps. Zero employees. AI agents handle the rest.
                    </p>
                </section>

                <section className="agent-stack">
                    <h2>The Vibe Entrepreneur Stack</h2>
                    <p className="stack-description">
                        Agents running 24/7 so I don't have to.
                    </p>

                    <div className="agent-grid">
                        <div className="agent-card">
                            <div className="agent-header">
                                <span className="agent-icon">&#x1f4c8;</span>
                                <div>
                                    <h3>ASA Agent</h3>
                                    <span className="agent-desc">Manages Apple Search Ads</span>
                                </div>
                                <span className="agent-freq">2x / day</span>
                            </div>
                        </div>

                        <div className="agent-card">
                            <div className="agent-header">
                                <span className="agent-icon">&#x1f50d;</span>
                                <div>
                                    <h3>Google Ads Agent</h3>
                                    <span className="agent-desc">Manages Google Ads campaigns</span>
                                </div>
                                <span className="agent-freq">2x / day</span>
                            </div>
                        </div>

                        <div className="agent-card">
                            <div className="agent-header">
                                <span className="agent-icon">&#x1f3a8;</span>
                                <div>
                                    <h3>Onboarding Optimizer</h3>
                                    <span className="agent-desc">Optimizes icons &amp; onboarding for apps</span>
                                </div>
                                <span className="agent-freq">Weekly</span>
                            </div>
                        </div>

                        <div className="agent-card">
                            <div className="agent-header">
                                <span className="agent-icon">&#x1f3ac;</span>
                                <div>
                                    <h3>Content Machines</h3>
                                    <span className="agent-desc">Posts short-form video for apps</span>
                                </div>
                                <span className="agent-freq">Daily</span>
                            </div>
                        </div>

                        <div className="agent-card">
                            <div className="agent-header">
                                <span className="agent-icon">&#x1f4ca;</span>
                                <div>
                                    <h3>App Analytics</h3>
                                    <span className="agent-desc">Collects metrics &amp; reports</span>
                                </div>
                                <span className="agent-freq">Daily</span>
                            </div>
                        </div>

                        <div className="agent-card">
                            <div className="agent-header">
                                <span className="agent-icon">&#x1f4b0;</span>
                                <div>
                                    <h3>Revenue Tracker</h3>
                                    <span className="agent-desc">Monitors LTV &amp; revenue</span>
                                </div>
                                <span className="agent-freq">Daily</span>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="projects-section">
                    <h2>Projects</h2>

                    <div className="project-group">
                        <h3 className="group-title">Flagship</h3>

                        <div className="project-card">
                            <div className="project-header">
                                <span className="project-emoji">&#x1f4c8;</span>
                                <div>
                                    <h3>ASA Agent</h3>
                                    <span className="project-tagline">Apple Search Ads on autopilot</span>
                                </div>
                                <div className="header-badges">
                                    <span className="year-badge">2026</span>
                                    <span className="status-badge live">Live</span>
                                </div>
                            </div>
                            <p className="project-description">
                                Built the ASA module for my own apps, then realized others need this too.
                                AI agent that manages your Apple Search Ads campaigns, optimizes bids
                                based on real revenue, and runs twice a day.
                            </p>
                            <div className="project-footer">
                                <a href="https://asaagent.xyz" target="_blank" rel="noopener noreferrer">
                                    asaagent.xyz &rarr;
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="project-group">
                        <h3 className="group-title">Run by AI</h3>
                        <p className="group-description">
                            These apps run on autopilot. AI agents handle ads, content, and optimization.
                        </p>

                        <div className="dating-twins">
                            <div className="project-card">
                                <div className="project-header">
                                    <span className="project-emoji">&#x1f34e;</span>
                                    <div>
                                        <h3>Eden</h3>
                                        <span className="project-tagline">AI dating coach</span>
                                    </div>
                                    <div className="header-badges">
                                        <span className="year-badge">2024</span>
                                        <span className="status-badge agent">Run by AI</span>
                                    </div>
                                </div>
                                <p className="project-description">
                                    Icebreaker's brother with a human face.
                                </p>
                                <div className="project-footer">
                                    <a href="https://apps.apple.com/us/app/eden-ai-your-dating-coach/id6503683930" target="_blank" rel="noopener noreferrer">
                                        App Store &rarr;
                                    </a>
                                </div>
                            </div>

                            <div className="project-card">
                                <div className="project-header">
                                    <span className="project-emoji">&#x1f9ca;</span>
                                    <div>
                                        <h3>Icebreaker</h3>
                                        <span className="project-tagline">AI wingman for dating apps</span>
                                    </div>
                                    <div className="header-badges">
                                        <span className="year-badge">2023</span>
                                        <span className="status-badge agent">Run by AI</span>
                                    </div>
                                </div>
                                <p className="project-description">
                                    One of the first apps in the rizz wave.
                                    Not my proudest work, but it pays the bills.
                                </p>
                                <div className="project-footer">
                                    <a href="https://apps.apple.com/us/app/icebreaker-your-ai-wingman/id6446773984" target="_blank" rel="noopener noreferrer">
                                        App Store &rarr;
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="project-group">
                        <h3 className="group-title">Building Now</h3>

                        <div className="project-card">
                            <div className="project-header">
                                <span className="project-emoji">&#x1f52e;</span>
                                <div>
                                    <h3>2035</h3>
                                    <span className="project-tagline">A letter from your future self</span>
                                </div>
                                <div className="header-badges">
                                    <span className="year-badge">2025</span>
                                    <span className="status-badge beta">Rebuilding</span>
                                </div>
                            </div>
                            <p className="project-description">
                                Manifestation app with video generation models. Took it down, reworking it.
                                Coming back stronger.
                            </p>
                            <div className="project-footer">
                                <a href="https://apps.apple.com/us/app/2035/id6751716799" target="_blank" rel="noopener noreferrer">
                                    App Store &rarr;
                                </a>
                            </div>
                        </div>

                        <div className="project-card">
                            <div className="project-header">
                                <span className="project-emoji">&#x1f9ca;</span>
                                <div>
                                    <h3>Bliss</h3>
                                    <span className="project-tagline">Cold plunge &amp; sauna tracker</span>
                                </div>
                                <div className="header-badges">
                                    <span className="year-badge">2026</span>
                                    <span className="status-badge beta">In Dev</span>
                                </div>
                            </div>
                            <p className="project-description">
                                Got hooked on ice baths and sauna contrast therapy. The rush is real.
                                107K+ monthly searches, zero dominant apps &mdash; so I'm building the tracker myself.
                            </p>
                            <div className="project-footer">
                                <span className="coming-soon">Coming soon</span>
                            </div>
                        </div>

                        <div className="project-card">
                            <div className="project-header">
                                <span className="project-emoji">&#x1f50d;</span>
                                <div>
                                    <h3>Google Ads Agent</h3>
                                    <span className="project-tagline">Google Ads on autopilot</span>
                                </div>
                                <div className="header-badges">
                                    <span className="year-badge">2026</span>
                                    <span className="status-badge beta">In Dev</span>
                                </div>
                            </div>
                            <p className="project-description">
                                Same idea as ASA Agent, but for Google Ads.
                                AI agent that optimizes campaigns based on real conversion data.
                            </p>
                            <div className="project-footer">
                                <span className="coming-soon">Coming soon</span>
                            </div>
                        </div>
                    </div>

                    <div className="project-group">
                        <h3 className="group-title">Experiments</h3>

                        <div className="project-card">
                            <div className="project-header">
                                <span className="project-emoji">&#x265f;&#xfe0f;</span>
                                <div>
                                    <h3>Opening Coach</h3>
                                    <span className="project-tagline">AI-powered opening trainer for chess</span>
                                </div>
                                <div className="header-badges">
                                    <span className="year-badge">2026</span>
                                    <span className="status-badge beta">In Dev</span>
                                </div>
                            </div>
                            <p className="project-description">
                                I play competitive chess and tournament prep is everything.
                                Openings are the highest ROI area to improve &mdash; a mix of raw memorization
                                and deep understanding of why each move works. AI is perfect for this.
                                Evolved from{' '}
                                <a href="https://chess-mistakes-trainer.fly.dev/" target="_blank" rel="noopener noreferrer">Chess Mistakes Trainer</a>.
                            </p>
                            <div className="project-footer">
                                <span className="coming-soon">Coming soon</span>
                            </div>
                        </div>

                        <div className="project-card">
                            <div className="project-header">
                                <span className="project-emoji">&#x1f9ed;</span>
                                <div>
                                    <h3>Compass</h3>
                                    <span className="project-tagline">AI that remembers your context</span>
                                </div>
                                <div className="header-badges">
                                    <span className="year-badge">2025</span>
                                    <span className="status-badge sunset">Experiment</span>
                                </div>
                            </div>
                            <p className="project-description">
                                Got hooked on talking to AI through voice and saving up massive context about myself.
                                Turned that experience into a mobile app.
                                Building with <a href="https://x.com/BenVFilippov" target="_blank" rel="noopener noreferrer">@BenVFilippov</a>.
                            </p>
                            <div className="project-footer">
                                <a href="https://testflight.apple.com/join/zCVctEub" target="_blank" rel="noopener noreferrer">
                                    Try on TestFlight &rarr;
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="project-group">
                        <h3 className="group-title">Origin Story</h3>

                        <div className="project-card dimmed">
                            <div className="project-header">
                                <span className="project-emoji">&#x2728;</span>
                                <div>
                                    <h3>Since</h3>
                                    <span className="project-tagline">Networking for creative Russians</span>
                                </div>
                                <div className="header-badges">
                                    <span className="year-badge">2021</span>
                                    <span className="status-badge sunset">Paused</span>
                                </div>
                            </div>
                            <p className="project-description">
                                My very first app. Lots of love, lots of mistakes.
                                People liked it. Dream of coming back to it.
                            </p>
                            <div className="project-footer">
                                <a href="https://apps.apple.com/us/app/since-interesting-people/id1576494400" target="_blank" rel="noopener noreferrer">
                                    App Store &rarr;
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="social-platforms">
                    <h2>Find Me</h2>
                    <div className="platform-list">
                        <a href="https://x.com/AkhmetovRail" target="_blank" rel="noopener noreferrer" className="platform-item">
                            <FaTwitter className="platform-icon" />
                            <div className="platform-content">
                                <h3>Twitter / X</h3>
                                <p>Vibe entrepreneurship &amp; AI agents</p>
                            </div>
                        </a>

                        <a href="https://t.me/path_to_svoboda" target="_blank" rel="noopener noreferrer" className="platform-item">
                            <FaTelegramPlane className="platform-icon" />
                            <div className="platform-content">
                                <h3>Telegram</h3>
                                <p>Deep essays on the journey (in Russian)</p>
                            </div>
                        </a>

                        <a href="https://www.linkedin.com/in/rail-akhmetov/" target="_blank" rel="noopener noreferrer" className="platform-item">
                            <FaLinkedinIn className="platform-icon" />
                            <div className="platform-content">
                                <h3>LinkedIn</h3>
                                <p>The professional version of all this</p>
                            </div>
                        </a>

                        <a href="https://www.instagram.com/akhrailxyz/" target="_blank" rel="noopener noreferrer" className="platform-item">
                            <FaInstagram className="platform-icon" />
                            <div className="platform-content">
                                <h3>Instagram</h3>
                                <p>Life, travels, chess, calisthenics</p>
                            </div>
                        </a>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default App;
